<template>
    <h1>404</h1>
    <span>Not Found</span>
</template>

<script>
export default {
    name: 'notFound',
}
</script>